import './PartReCategorizationComponent.scss';
import React from "react";
import {ExpandMore} from "@mui/icons-material";
import {ButtonBase, Chip, Stack, Tooltip} from "@mui/material";
import ChevronIcon from "~/icons/svg/ChevronIcon.svg?react";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {categoryChipArrowStyle, getCategoryChipSx} from "./categoryChip.utils.ts";

type Props = {
    cats: string[] | false
    handleOpenSearch: (event: React.MouseEvent<HTMLButtonElement>) => void
    selectedL1Category: string | undefined,
}
export const PartReCategorizationComponent: React.FC<Props> = ({
                                                                   cats,
                                                                   handleOpenSearch,
                                                                   selectedL1Category,
                                                               }) => {
    const catsIsUncategorized = cats === false
        || cats.length === 0
        || cats.every(c => c === UNCATEGORIZED_VALUE)
    ;
    return <ButtonBase sx={{display: 'block', width: '100%'}} className="part-recat-component"
                       onClick={handleOpenSearch}>
        {catsIsUncategorized
            ? <Chip
                variant="outlined"
                color="error"
                size="small"
                deleteIcon={<ExpandMore/>}
                onDelete={handleOpenSearch}
                label={UNCATEGORIZED_LABEL}
                sx={getCategoryChipSx()}
            />
            : <Stack
                direction="row"
                flexWrap="nowrap"
                alignItems="center"
                minWidth={0}
                overflow="hidden"
                width="100%"
                gap="4px"
            >
                {(cats as string[]).map((c, i) => {
                    const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
                    return <React.Fragment key={i}>
                        <Tooltip arrow title={categoryLabel} enterTouchDelay={0} leaveTouchDelay={3000}>
                            <Chip
                                variant={cats.length - 1 === i ? "filled" : "outlined"}
                                color={selectedL1Category === c ? "primary" : "info"}
                                size="small"
                                deleteIcon={(i === (cats as string[]).length - 1) ? <ExpandMore/> : undefined}
                                onDelete={(i === (cats as string[]).length - 1) ? handleOpenSearch : undefined}
                                label={categoryLabel}
                                sx={{...getCategoryChipSx(), minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis'}}
                            />
                        </Tooltip>
                        {(i < (cats as string[]).length - 1) &&
                            <ChevronIcon style={categoryChipArrowStyle} fontSize="small"/>}
                    </React.Fragment>;
                })}
            </Stack>
        }
        {/* </ButtonBase> */}
    </ButtonBase>;
}
